import React from 'react';
import ResponsiveLayout from 'src/components/ResponsiveLayout';
import BannerDesktop from './BannerDesktop';
import BannerMobile from './BannerMobile';

const BannerHowToPlay = (props) => {
  return (
    <ResponsiveLayout
      desktopView={<BannerDesktop {...props} />}
      mobileView={<BannerMobile {...props} />}
    />
  );
};

export default BannerHowToPlay;